module.exports = __webpack_public_path__ + "static/media/CourseImport.846ebd6c.xlsx";